import { Grid } from 'antd';

/** 与 kfc-web 同一断点：Ant Design md（768px）以下视为窄屏。 */
export function useNarrowScreen(): boolean {
  const screens = Grid.useBreakpoint();
  return screens.md === false;
}
